import React, { useState, useEffect } from 'react'
import { useTheme, alpha } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import defaultTexts from '../../texts/texts'
import constants from '../../config/constants'
import { request } from '../../_network/request'
import { externalAppsURLs } from '../../_network/apiUrls'
import { isAlphanumeric } from '../_common/_helpers/validation'
import CustomTextField from '../_common/_form_fields/CustomTextField'
import CustomBackdrop from '../_common/CustomBackdrop'

const ExternalApplicationAdd = (props) => {
  const { handleAddApplicationDialogClose, setFetchApplications, applications, currentRecord } = props
  const theme = useTheme()

  const [name, setName] = useState('')
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const formControlStyle = {
    background: theme.palette.aliceBlue,
    color: theme.palette.vodka,
    borderRadius: '5px',
    width: '100%',
  }

  const outlinedInputStyle = {
    '& .MuiInputBase-input::label': {
      color: theme.palette.vodka,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.vodka,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.vodka,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.vodka,
    },
  }

  const errorHelperStyle = {
    color: theme.palette.coralRed,
    paddingLeft: '5px',
  }

  const fieldBoxStyle = {
    padding: '12px 0px'
  }

  const saveButtonStyle = {
    fontWeight: '500',
    color: 'white',
    background: theme.palette.greenSheen,
    fontSize: '18px',
    height: '40px',
    borderRadius: '20px',
    padding: '0px 30px',
    marginTop: '20px',
    textTransform: 'capitalize',

    '&:hover': {
      background: alpha(theme.palette.greenSheen, 0.8),
    },
  }

  const handleChangeName = (e) => {
    const value = e.target.value
    
    setName(value)

    if (isAlphanumeric(value)) {
      setError(null)
    }
  }

  const getIfNameExists = () => {
    const application_object = applications.find(item => item.name === name)
    return (currentRecord && application_object && currentRecord.name !== application_object.name) || (!currentRecord && application_object)
  }

  const applicationRequest = async (postData) => {
    const action = currentRecord ? `/${currentRecord.id}` : ''
    const url = constants.core_service_domain + '/' + externalAppsURLs.getExternalApps + action
    const method = currentRecord ? 'PUT' : 'POST'
      
    const request_data = { url, method, data: postData }
    
    const response = await request(request_data)
    
    if (response && response.status_code && response.status_code < 400) {
      handleAddApplicationDialogClose()
      setFetchApplications(prev => prev + 1)
    } else {
      setError(defaultTexts.anErrorOccured)
    }
  }

  const handleClickSubmit = async () => {
    setIsLoading(true)

    const nameExists = getIfNameExists()

    if (name && isAlphanumeric(name) && !nameExists) {
      await applicationRequest({ name })
    } else if (name && isAlphanumeric(name)) {
      setError(defaultTexts.applicationAlreadyExists)
    } else {
      setError(defaultTexts.applicationNameRequirements)
    }

    setIsLoading(false)
  }

  useEffect(() => {
    if (currentRecord) {
      setName(currentRecord.name)
    }
  }, [currentRecord])

  return (
    <Box>
      { isLoading && <CustomBackdrop open={isLoading} /> }

      <Box sx={fieldBoxStyle}>
        <CustomTextField 
          variant='outlined'
          label={defaultTexts.applicationName}
          currentValue={name}
          setCurrentValue={handleChangeName}
          required={true}
          error={error ? true : false}
          loginHelperText={error}
          loginHelperSx={errorHelperStyle}
          size='small'
          sx={formControlStyle}
          outlinedInputSx={outlinedInputStyle}
        />
      </Box>

      <Stack
        direction='row'
        justifyContent='flex-end'
      >
        <Button
          variant='contained'
          disableRipple
          disableElevation
          disabled={false}
          onClick={handleClickSubmit}
          sx={saveButtonStyle}
        >
          {defaultTexts.save}
        </Button>
      </Stack>
    </Box>
  )
}

export default ExternalApplicationAdd